// formNames.js
export const FORM_NAMES = {
  EMPLOYEE_LIST: {
    ADD_EMPLOYEE: "Add Employee",
  },
  GRADE_TEST: "Grade Test 2",
  FORM_BUILDER_27: "Form Builder 27 v1",

  SETTINGS: {
    BUSINESS: "Business",
  },
  // Add all your form names here
};
